import React from "react";
import { Alert } from "../";
import AuditLog from "./AuditLog";
import { useAppContext } from "../../context/appContext";
import { Select } from "../workspace";

const AdminCustomSettings = () => {
  const { isLoading, job, showAlert, lists, handleChange, saveRecord } = useAppContext();

  const handleInput = (e, baseObject) => {
    const name = e.target.name;
    const value = e.target.value;
    handleChange({ baseObject, name, value });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    saveRecord(`/core-job/update/${job.id}`, job, "Core Job Info");
    console.log("update records");
  };
  return (
    <>
      <div className="group whole">
        <form onSubmit={handleSubmit} className="form">
          <h3>Custom Settings</h3>
          {showAlert && <Alert />}
          <div className="form-center">
            <div className="one-half">
              <Select
                name="job.job_type_id"
                labelText="Change Job Type for Current Job"
                value={job.job_type_id}
                handleChange={(e) => handleInput(e, { ...job })}
                options={lists && lists.listJobTypes}
              />
            </div>
            <div className="one-half">
              <Select
                name="job.price_sheets_id"
                labelText="Change Price Sheet for Current Job"
                value={job.price_sheets_id}
                handleChange={(e) => handleInput(e, { ...job })}
                options={lists && lists.listPriceSheets}
              />
            </div>

            <button className="btn btn-block" type="submit" disabled={isLoading}>
              {isLoading ? "please wait..." : "Save Changes"}
            </button>
          </div>
        </form>
      </div>
    </>
  );
};
export default AdminCustomSettings;
